<template>
  <IndexPanel
    v-if="listItems.length > 0"
    :initialData="listItems"
    :modelValue="searchResults"
    operationType="ships"
  />

  <OperationList
    v-slot="slotProps"
    :listItems="searchResults"
    operationType="ships"
  >
    <!-- SHIPS -->
    <OperationItem
      v-for="item in slotProps.item.ships"
      :id="item.id"
      :key="item.id"
      barChart
      endpointIdentifier="ships"
      :itemRoutes="{
        view: { name: 'ship', params: { shipId: item.id } },
        edit: { name: 'shipConfigurationShips', params: { organisationId: props.organisationId, shipId: item.id } },
      }"
      :organisationId="organisationId"
      @reload="reload"
    />
  </OperationList>
</template>

<script setup>
import { onMounted, ref, watch, computed } from 'vue';
import useAjax from '@/functions/use_ajax';

// Components
import OperationList from '@/components/operations/operations_list.vue';
import OperationItem from '@/components/operations/operation_item.vue';
import IndexPanel from '@/components/form/index_panel.vue';

const emit = defineEmits(['update']);

const props = defineProps({
  organisationId: { type: String, default: null },
});

const ajax = useAjax();
const listItems = ref([]);
const loading = ref(true);
const searchResults = ref([]);

const itemCount = computed(() => {
  return searchResults.value?.reduce(function (acc, obj) {
    return acc + (obj.ships?.length || 0);
  }, 0);
});

onMounted(load);
watch(props, load);
watch(itemCount, emitCount);

function emitCount() {
  emit('update', {
    count: itemCount.value || 0,
    label: 'ships',
    loading: loading.value,
  });
}

async function load() {
  await loadShips();
  loading.value = false;

  emitCount();
}

async function loadShips() {
  let { ok, data } = await ajax(`/organisations/${props.organisationId}/ships`);

  if (ok) {
    listItems.value = JSON.parse(JSON.stringify(data.divisions));
    searchResults.value = data.divisions;
  }
}

function reload(data) {
  if (data?.type === 'delete') {
    listItems.value.forEach((division, index) => {
      division.ships = division?.ships.filter(operation => operation.id !== data?.id);
      searchResults.value[index].ships = searchResults.value[index]?.ships.filter(operation => operation.id !== data?.id);
    });
  }
}
</script>
